import { buildWhatsAppUrl } from "@/lib/api";
import { MessageCircle } from "lucide-react";

export default function WhatsAppButton({ number, message, label = "Contattami su WhatsApp", testid = "whatsapp-btn", className = "" }) {
  if (!number) return null;
  return (
    <a
      data-testid={testid}
      href={buildWhatsAppUrl(number, message)}
      target="_blank"
      rel="noopener noreferrer"
      className={`inline-flex items-center justify-center gap-2 h-14 px-6 rounded-xl bg-[#25D366] text-white font-medium hover:bg-[#1EBE5A] transition-colors duration-300 ${className}`}
    >
      <MessageCircle size={18} strokeWidth={1.8} />
      {label}
    </a>
  );
}
